const translations = {
    'settlement.city': 'Miasto: %s',
    'settlement.defaultName': 'Pierwsza osada',
    'settlement.population': 'Populacja: %d/%d (wolni %d)',
    'settlement.tier': 'Poziom: %s',
    'settlement.title': 'Szczegóły miasta',
    'population.section.food': 'Żywność',
    'population.section.heat': 'Ogrzewanie',
    'population.food.target': 'Cel domu: %d h',
    'population.food.setTarget': 'Ustaw cel zapasu żywności',
    'population.food.reserve': 'Zapas: %s',
    'population.heat.balance': 'Bilans paliwa: %s ciepła/h',
    'population.heat.target': 'Cel domu: %d h',
    'population.heat.setTarget': 'Ustaw cel zapasu opału',
    'population.heat.reserve': 'Zapas paliwa: %s',
    'population.heat.coldRate': 'Tempo wychładzania: %s',
    'population.heat.freeze': 'Zamarznięcie za: %s',
    'population.heat.units': '%.1f ciepła',
    'population.heat.unitsPerHour': '%.1f ciepła/h',
    'population.hours': '%.1f h',
    'population.stable': 'Stabilnie',
    'population.unknown': 'Za mało danych',
    'population.house.title': 'Dom %d',
    'population.houses.title': 'Domy',
    'population.houses.hint': 'Kliknij dom, aby zobaczyc mieszkancow.',
    'population.houses.selectHint': 'Wybierz dom powyzej, aby zobaczyc szczegóły.',
    'population.house.occupants': 'Mieszkancy: %d',
    'population.house.warmth': 'Ciepło: %s',
    'population.house.food': 'Jedzenie: %s',
    'population.house.wood': 'Drewno: %s',
    'population.house.charcoal': 'Węgiel: %s',
    'population.people.title': 'Mieszkancy domu %d',
    'population.people.title.none': 'Mieszkancy',
    'population.people.empty': 'Brak mieszkancow.',
    'population.people.job': 'Praca: %s',
    'population.people.hunger': 'Glod: %d/%d',
    'population.people.warmth': 'Cieplo: %d/%d',
};

export default translations;
